import { render, staticRenderFns } from "./DashboardReportModal.vue?vue&type=template&id=08b8586d&"
import script from "./DashboardReportModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardReportModal.vue?vue&type=style&index=0&id=08b8586d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports